import { Dispatch, SetStateAction } from 'react'
import { Button } from 'primereact/button'
import styled, { css } from 'styled-components'
import moment from 'moment'

// local imports
import DateUtil from 'utils/DateUtil'
import { IGetMeetingRoomTimeTableList } from 'types/MeetingRoomType'

interface SchedulerProps {
  filterDate: Date
  setFilterDate: Dispatch<SetStateAction<Date>>
  tableWeek: { start: Date; end: Date }
  dailyAppointments: any
  setSelectedReservations: Dispatch<SetStateAction<IGetMeetingRoomTimeTableList[] | undefined>>
  selectedReservations: IGetMeetingRoomTimeTableList[] | undefined
}

export default function Scheduler({
  filterDate,
  setFilterDate,
  dailyAppointments,
  setSelectedReservations,
  selectedReservations,
  tableWeek,
}: SchedulerProps) {
  const hours = [...Object.values(dailyAppointments)]
  const weekDays = DateUtil.getWeekDayRange(tableWeek.start, tableWeek.end)
  const selectedDayByFilter = moment(filterDate).format('Do MMMM dddd')
  const selectedTime = moment(selectedReservations?.[0]?.reservationStartHour).format('Do MMMM dddd')
  const selectedDay = weekDays.find((wd) => wd === selectedTime)
  const isTimeSelected = (hour: IGetMeetingRoomTimeTableList) => {
    if (!!selectedReservations && selectedReservations?.length > 0) {
      const formattedArr = selectedReservations?.map((sr) => `${sr?.reservationStartHour}-${sr?.reservationEndHour}`)
      const result = formattedArr.includes(`${hour.reservationStartHour}-${hour.reservationEndHour}`)
      return result ? 'selected' : ''
    }
  }

  const isDaySelected = (day: string) => {
    if (!selectedReservations) return day === selectedDayByFilter
    else return day === selectedDay
  }

  console.log(selectedReservations, 'seçili time..')

  const handleChooseTime = (data: IGetMeetingRoomTimeTableList) => {
    setSelectedReservations((prev) => {
      if (!!prev && prev.length > 0) {
        // if the selection is made for a different day, state will be resett.
        const newDate = new Date(data.reservationStartHour)
        const isDifferentDay = prev.some((p) => {
          const prevDate = new Date(p.reservationStartHour)
          return newDate.getDate() !== prevDate.getDate()
        })
        if (isDifferentDay) return [data]
        // different day selection control

        // if clicked reservationTime already exists, remove it from the state array
        const prevStartHours = prev.map((p) => p.reservationStartHour)
        if (prevStartHours.includes(data.reservationStartHour)) {
          return prev.filter((p) => p.reservationStartHour !== data.reservationStartHour)
        }

        // push new reservationTime to the state array
        return [...prev, data]
      } else return [data]
    })
    const date = new Date(data.reservationStartHour)
    setFilterDate(date)
  }

  return (
    <>
      <HeaderWrapper>
        {weekDays.map((day) => (
          <DayHeader key={day} selected={isDaySelected(day)}>
            <span>{day}</span>
          </DayHeader>
        ))}
      </HeaderWrapper>

      <GridWrapper>
        <GridContainer>
          {hours?.map((hour: any, index) => (
            <GridItem key={index}>
              {hour?.map((h: IGetMeetingRoomTimeTableList) => (
                <TimeButton
                  disabled={!h.isSelectable}
                  id={`${h.reservationStartHour}-${h.reservationEndHour}`}
                  onClick={() => handleChooseTime(h)}
                  className={isTimeSelected(h)}
                  key={`${h.reservationStartHour}-${h.reservationEndHour}`}>
                  <span>
                    {h.reservationStartHourStr} - {h.reservationEndHourStr}
                  </span>
                </TimeButton>
              ))}
            </GridItem>
          ))}
        </GridContainer>
      </GridWrapper>
    </>
  )
}

const HeaderWrapper = styled.div`
  display: flex;
  width: calc(100% - 10px);
  border: 1px solid #ebebeb;
  border-radius: 4px;
`
const DayHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-grow: 1;
  height: 40px;
  font-size: 14px;
  line-height: 17px;
  font-weight: 700;
  color: #363636;

  ${({ selected }: { selected: boolean }) =>
    selected &&
    css`
      background: #e3f5fb;
      border-bottom: 1px solid #ebebeb;
    `}
`

const GridWrapper = styled.div`
  overflow-y: auto;
  max-height: calc(100% - 200px);
  width: calc(100% - 6px) !important;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: #d3d3d3 !important;
  }

  &::-webkit-scrollbar {
    height: 6px;
    width: 6px !important;
    background-color: #d3d3d3;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #7c7c7c;
  }
`

const GridContainer = styled.div`
  display: flex;
  padding: 0px;
`

const GridItem = styled.div`
  display: flex;
  padding: 0 10px;
  width: 100%;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-right: 1px solid #ebebeb;

  .selected {
    background: #45bfe5 !important;
    color: #fff !important;
  }

  &:last-child {
    border-right: none;
  }
`

const TimeButton = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed !important;
      border: none !important;
    `}

  cursor: pointer;
  padding: 0;
  margin: 5px 0;
  width: 100%;
  height: 30px;
  background: #ffffff;
  border: 0.5px solid #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #363636;

  &:disabled {
    opacity: 0.4 !important;
  }

  &:hover {
    background: #45bfe5 !important;
    color: #fff !important;
  }
`
